<template lang="html">
  <div class="create-profile-wrapper">
    <div class="form-progress-wrap edit-profile basic-info-wrap">
      <BaseLoading  :spinning="clubLoading">
        <div class="container">
          <div class="steps-content">
            <div class="general-form-wrap">
              <div class="general-form">
                <div class="image-upload box-wrapper">
                  <div class="heading">
                    <h2 class="form-title">Upload Club Profile Picture or Logo</h2>
                  </div>
                  <BaseDragUpload
                    cannot-delete
                    label="Click this area to upload or change photo"
                    class="drag-image-wrapper"
                    @file-upload="
                      image => {
                        imageSrc = image;
                      }
                    "
                    :image-url="imageUrl"
                  />
                </div>
                <FormModel
                  :model="resource"
                  ref="form"
                  @submit.prevent.native="handleFormSubmit"
                  class="basic-information-form-wrapper"
                  :rules="validationRules"
                >
                  <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Basic Information</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="clubName"
                          :value="resource.clubName"
                          label="Club Name"
                          placeholder="Enter name"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'clubName'
                              )
                          "
                          name="clubName"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="clubPhone"
                          :value="resource.clubPhone"
                          label="Phone Number"
                          placeholder="Phone Number"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'clubPhone'
                              )
                          "
                          name="clubPhone"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.url"
                          label="Club Page Url"
                          placeholder="Club Page Url"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'url')
                          "
                          name="url"
                        />
                      </a-col>
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="resource.description"
                          label="Enter Club Description"
                          placeholder="Enter Club Description"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'description'
                              )
                          "
                          name="description"
                          type="textarea"
                        />
                      </a-col>
                      <a-col :sm="24">
                        <BaseTaxonomySelect
                          ref="ageGroupId"
                          resource="ageGroup"
                          placeholder="Select Age Group"
                          type="Age Group"
                          label="Age Group"
                          name="ageGroupId"
                          :value="resource.ageGroupId"
                          @change="
                            value => handleFormValueChange(value, 'ageGroupId')
                          "
                        />
                      </a-col>
                    </a-row>
                    <div class="general-info box-wrapper">
                      <div class="heading">
                        <h2 class="form-title">Social Media Links</h2>
                      </div>
                      <a-row :gutter="32">
                        <a-col :sm="24" :md="8">
                          <BaseFormInput
                            :value="resource.facebook"
                            label="Facebook"
                            placeholder="Enter Description"
                            @change="
                              event =>
                                handleFormValueChange(
                                  event.target.value,
                                  'facebook'
                                )
                            "
                            name="facebook"
                          />
                        </a-col>
                        <a-col :sm="24" :md="8">
                          <BaseFormInput
                            :value="resource.instagram"
                            label="Instagram"
                            placeholder="Enter instagram"
                            @change="
                              event =>
                                handleFormValueChange(
                                  event.target.value,
                                  'instagram'
                                )
                            "
                            name="instagram"
                          />
                        </a-col>
                        <a-col :sm="24" :md="8">
                          <BaseFormInput
                            :value="resource.twitter"
                            label="Twitter"
                            placeholder="Enter twitter"
                            @change="
                              event =>
                                handleFormValueChange(
                                  event.target.value,
                                  'twitter'
                                )
                            "
                            name="twitter"
                          />
                        </a-col>
                        <a-col :sm="24" :md="8">
                          <BaseFormInput
                            :value="resource.linkedin"
                            label="Linkedin"
                            placeholder="Enter linkedin"
                            @change="
                              event =>
                                handleFormValueChange(
                                  event.target.value,
                                  'linkedin'
                                )
                            "
                            name="linkedin"
                          />
                        </a-col>
                        <a-col :sm="24" :md="8">
                          <BaseFormInput
                            :value="resource.youtube"
                            label="Youtube"
                            placeholder="Enter youtube"
                            @change="
                              event =>
                                handleFormValueChange(
                                  event.target.value,
                                  'youtube'
                                )
                            "
                            name="youtube"
                          />
                        </a-col>
                        <a-col :sm="24" :md="8">
                          <BaseFormInput
                            :value="resource.podcast"
                            label="Podcast"
                            placeholder="Enter podcast"
                            @change="
                              event =>
                                handleFormValueChange(
                                  event.target.value,
                                  'podcast'
                                )
                            "
                            name="podcast"
                          />
                        </a-col>
                      </a-row>
                    </div>
                  </div>
                  <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Location Information</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="city"
                          :value="resource.city"
                          label="City"
                          placeholder="Enter City"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'city')
                          "
                          name="city"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseSortedTaxonomySelect
                          ref="stateId"
                          resource="state"
                          placeholder="Enter State"
                          type="State"
                          label="State"
                          label-path="name"
                          value-path="Id"
                          :value="resource.stateId"
                          @change="
                            value => handleFormValueChange(value, 'stateId')
                          "
                          name="stateId"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="zip"
                          :value="resource.zip"
                          label="ZIP"
                          placeholder="Enter zip"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'zip')
                          "
                          name="zip"
                        />
                      </a-col>
                      <a-col :sm="24" :md="9">
                        <BaseFormInput
                          ref="address1"
                          :value="resource.address1"
                          label="Address"
                          placeholder="Address"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'address1'
                              )
                          "
                          name="address1"
                        />
                      </a-col>
                    </a-row>
                  </div>
                  <!-- <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Social Media Links</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.facebook"
                          label="Facebook"
                          placeholder="Enter Facebook Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'facebook'
                              )
                          "
                          name="facebook"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          placeholder="Enter Twitter Link"
                          label="Twitter"
                          :value="resource.twitter"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'twitter'
                              )
                          "
                          name="twitter"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.flickr"
                          label="Flicker"
                          placeholder="Enter Flicker Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'flickr'
                              )
                          "
                          name="flickr"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.youtube"
                          label="Youtube"
                          placeholder="Enter Youtube Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'youtube'
                              )
                          "
                          name="youtube"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.linkedin"
                          label="Linkedin"
                          placeholder="Enter Linkedin Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'linkedin'
                              )
                          "
                          name="linkedin"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.podcast"
                          label="Podcast"
                          placeholder="Enter Podcast Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'podcast'
                              )
                          "
                          name="podcast"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.instagram"
                          label="Instagram"
                          placeholder="Enter Instagram Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'instagram'
                              )
                          "
                          name="instagram"
                        />
                      </a-col>
                    </a-row>
                  </div> -->
                  <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Additional Information</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="resource.info"
                          label="Additional Info"
                          placeholder="Enter Additional Info"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'info')
                          "
                          name="info"
                          type="textarea"
                        />
                      </a-col>
                    </a-row>
                  </div>
                  <div class="margined-content">
                    <BaseButton
                      type="primary"
                      html-type="submit"
                      :loading="clubLoading"
                    >
                      Submit
                    </BaseButton>
                  </div>
                </FormModel>
              </div>
            </div>
          </div>
        </div>
      </BaseLoading>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FormModel } from "ant-design-vue";
import { Club } from "@/models";

const STORE_KEY = "clubStore";

export default {
  data() {
    return {
      resource: new Club(),
      imageSrc: "",
      validationRules: Club.validationRules,
      imageUrl: ""
    };
  },
  components: {
    FormModel
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getClub`, {
      id: localStorage["club-id"]
    });
  },
  methods: {
    handleFormValueChange(value, key) {
      this.resource = new Club({ ...this.resource, [key]: value });
    },
    async handleFormSubmit() {
      this.$refs.form.validate(async (valid, error) => {
        if (!valid) this.$refs[Object.keys(error)[0]].$refs.formInput.focus();
        if (valid) {
          await this.$store.dispatch(`${STORE_KEY}/updateClub`, {
            id: this.resource.id,
            clubName: this.resource.clubName,
            url: this.resource.url,
            description: this.resource.description,
            city: this.resource.city,
            info: this.resource.info,
            clubPhone: this.resource.clubPhone,
            zip: this.resource.zip,
            address1: this.resource.address1,
            address2: this.resource.address2,
            state: this.resource.stateId,
            age: this.resource.ageGroupId,
            facebook: this.resource.facebook,
            linkedin: this.resource.linkedin,
            instagram: this.resource.instagram,
            twitter: this.resource.twitter,
            flickr: this.resource.flickr,
            youtube: this.resource.youtube,
            podcast: this.resource.podcast,
            slug: "clubprofile"
          });
          let formData = new FormData();
          formData.append("logo", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(`${STORE_KEY}/updateClubLogo`, {
              id: this.resource.id,
              image: formData
            }));
          this.imageSrc = "";
          await this.$store.dispatch(`${STORE_KEY}/getClub`, {
            id: localStorage["club-id"]
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      club: `${STORE_KEY}/club`,
      clubLoading: `${STORE_KEY}/clubLoading`
    })
  },
  watch: {
    club(newVal, _) {
      this.resource = new Club(newVal);
      this.imageUrl = newVal.logo;
    }
  }
};
</script>

<style lang="sass" scoped>
.image-upload-box-wrapper
  margin-bottom: 2rem
  padding: 40px 40px
  border: 1px dashed #e9e9e9
  border-radius: 6px
  background: #d23129 !important
  display: flex
  flex-direction: column
  align-items: center
  .drag-image-wrapper
    margin-top: 1rem
    width: 50%
    border-radius: 5px
    /deep/ label
      display: none !important
    /deep/ .upload-wrapper
      border-radius: 5px
      .ant-upload-text
        font-size: 1.5rem
        color: black
      .ant-upload-drag-icon
        font-size: 2rem
        color: rgb(92, 169, 248)
  .heading
    display: flex
    width: 100%
    justify-content: center
    color: #ffffff
    font-size: 2rem
.background-light-gray
  background: #f0f0f0
  border-radius: 5px
  .content
    margin-top: 0rem !important
.basic-information-form-wrapper
  .margined-content
    margin-top: 3rem
  &:first-child
    margin-top: 0rem !important
  .basic-info-wrapper, .location-information-wrapper
    display: grid
    grid-template-columns: repeat(auto-fill, 25.5rem)
    .ant-form-item
      width: 95%
      /deep/ textarea
        height: 8rem !important
    .grid-item-2
      width: 98% !important
      grid-column-start: span 3
  .additional-info-wrapper
    display: grid
    grid-template-columns: repeat(auto-fill, 35rem)
    .ant-form-item
      width: 95%
      /deep/ textarea
        height: 8rem !important
</style>
